import { create } from "lodash";
import { fetchItemsWS } from "../webservices/fetchWS";
import { QnaireAnalysisDTO } from "./DTOs/qnaireAnalysisDTO";
import { createItemWs, updateItemWs } from "../webservices/saveWS";
import { analyseCustomQuery, analyseQnaire, crossTableAnalysis } from "../webservices/deepAnalysisWS";
import { toast } from "react-toastify";
import { CustomAnalysisDTO } from "./DTOs/CustomAnalysisDTO";
import { CrossTableDTO } from "./DTOs/CrossTableDTO";
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";


export const FETCH_CUSTOM_QUERIES_SUCCESS_ACTION = "FETCH_CUSTOM_QUERIES_SUCCESS_ACTION";
export const FETCH_CUSTOM_QUERIES_ERROR_ACTION = "FETCH_CUSTOM_QUERIES_ERROR_ACTION";

export const fetchCustomQueriesAction = (tenant) => {
  const queryParams = {
    PK: `${tenant.id}%23CUSTOMANALYSIS`,
    SK: `ANALYSIS%23`,
  };

  return (dispatch, getState) => {
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.op !== "d");
        dispatch({
          type: "FETCH_CUSTOM_QUERIES_SUCCESS_ACTION",
          payload: returnItems,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "FETCH_CUSTOM_QUERIES_ERROR_ACTION", err });
      });
  };
}

export const FETCH_DEEPANALYSIS_QUESTIONS_SUCCESS_ACTION = "FETCH_DEEPANALYSIS_QUESTIONS_SUCCESS_ACTION";
export const FETCH_DEEPANALYSIS_QUESTIONS_ERROR_ACTION = "FETCH_DEEPANALYSIS_QUESTIONS_ERROR_ACTION";

export const fetchQuestionsAction = (questionaireId, sectionId, tenantId) => {
  const queryParams = {
    PK: `${tenantId}%23QNAIRE%23${questionaireId}`,
    SK: 'QUESTION%23',
  };

  return (dispatch, getState) => {
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.op !== "d");
        dispatch({
          type: FETCH_DEEPANALYSIS_QUESTIONS_SUCCESS_ACTION,
          payload: returnItems,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_DEEPANALYSIS_QUESTIONS_ERROR_ACTION, err });
      });
  };
};

export const FETCH_QNAIREANALYSIS_QUERY_SUCCESS_ACTION = "FETCH_QNAIREANALYSIS_QUERY_SUCCESS_ACTION";
export const FETCH_QNAIREANALYSIS_QUERY_ERROR_ACTION = "FETCH_QNAIREANALYSIS_QUERY_ERROR_ACTION";

export const fetchQuestionnaireAnalysisAction = (questionnaireId, tenantId) => {
  const queryParams = {
    PK: `${tenantId}%23QNAIREANALYSIS`,
    SK: `${questionnaireId}%23ANALYSIS`,
  };

  return (dispatch, getState) => {
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        // Filter to get only the most recent item based on createdAt date
        let mostRecentItem = null;

        if (result.Items && result.Items.length > 0) {
          mostRecentItem = result.Items.reduce((latest, current) => {
            // If no createdAt field, keep the latest found so far
            if (!current.createdAt) return latest;

            // If no latest yet, or current is newer than latest
            if (!latest || !latest.createdAt || current.createdAt > latest.createdAt) {
              return current;
            }
            return latest;
          }, null);
        }

        dispatch({
          type: FETCH_QNAIREANALYSIS_QUERY_SUCCESS_ACTION,
          payload: mostRecentItem ? [mostRecentItem] : [],
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_QNAIREANALYSIS_QUERY_ERROR_ACTION, err });
      });
  };
}

export const analyseQnaireAction = (payload) => {
  return async (dispatch, getState) => {
    try {
      const saveObject = new QnaireAnalysisDTO(payload);
      const result = await createItemWs(saveObject, getState);
      const queryId = result.data.id;
      const payloadWithQueryId = { ...payload, queryId };
      await analyseQnaire(payloadWithQueryId, getState);
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };
}

export const ADD_CUSTOMANALYSIS_QUERY_ACTION = "ADD_CUSTOMANALYSIS_QUERY_ACTION";

export const analyseCustomQueryAction = (payload) => {
  return async (dispatch, getState) => {
    try {
      const saveObject = new CustomAnalysisDTO(payload);
      const result = await createItemWs(saveObject, getState);
      const queryId = result.data.id;
      const payloadWithQueryId = { ...payload, queryId };
      await analyseCustomQuery(payloadWithQueryId, getState);
      dispatch({
        type: ADD_CUSTOMANALYSIS_QUERY_ACTION,
        payload: payloadWithQueryId,
      });
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };
}

export const FETCH_CROSSTABLE_DATA_SUCCESS_ACTION = "FETCH_CROSSTABLE_DATA_SUCCESS_ACTION";
export const FETCH_CROSSTABLE_DATA_ERROR_ACTION = "FETCH_CROSSTABLE_DATA_ERROR_ACTION";

export const fetchCrossTableDataAction = (tenant) => {
  const queryParams = {
    PK: `${tenant.id}%23CROSSTABLEANALYSIS`,
    SK: `ANALYSIS%23`,
  };

  return (dispatch, getState) => {
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter(item => item.op !== "d");
        dispatch({
          type: FETCH_CROSSTABLE_DATA_SUCCESS_ACTION,
          payload: returnItems,
        });

        // Fetch S3 data if we have cross table data
        if (returnItems && returnItems.length > 0) {
          dispatch(fetchCrossTableS3DataAction(returnItems, tenant));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_CROSSTABLE_DATA_ERROR_ACTION, err });
      });
  };
}

export const FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION = "FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION";
export const FETCH_CROSSTABLE_S3_DATA_ERROR_ACTION = "FETCH_CROSSTABLE_S3_DATA_ERROR_ACTION";
export const FETCH_CROSSTABLE_S3_DATA_LOADING_ACTION = "FETCH_CROSSTABLE_S3_DATA_LOADING_ACTION";
export const CLEAR_CROSSTABLE_S3_DATA_ACTION = "CLEAR_CROSSTABLE_S3_DATA_ACTION";

export const clearCrossTableS3DataAction = () => ({
  type: CLEAR_CROSSTABLE_S3_DATA_ACTION
});

export const fetchCrossTableS3DataAction = (crossTableData, tenant) => {
  return async (dispatch, getState) => {
    try {
      // Check if we have the required data to build S3 path
      if (!crossTableData || !Array.isArray(crossTableData) || crossTableData.length === 0) {
        console.log('No cross table data available to fetch S3 results');
        return;
      }

      dispatch({ type: FETCH_CROSSTABLE_S3_DATA_LOADING_ACTION });

      const crossTableDataObj = crossTableData[0];

      // Build S3 path using the cross table data
      // Typical pattern: {env}/crosstables/{tenantId}/{analysisId}.json
      const s3Path = `${process.env.REACT_APP_ENV}/crosstables/${tenant.id}/${crossTableDataObj.id}.json`;

      console.log('Fetching cross table results from S3 path:', s3Path);

      // Import Storage dynamically to avoid issues
      const { Storage } = await import('aws-amplify');

      // Fetch the analysis results from S3 with cache busting
      const s3Result = await Storage.get(s3Path, {
        level: 'public',
        download: true,
        cacheControl: 'no-cache',
        expires: new Date(Date.now() + 1000) // Expire immediately
      });

      // Parse the JSON content with NaN handling
      let analysisResults;
      if (s3Result.Body) {
        let text = await s3Result.Body.text();

        // Handle NaN values by replacing them with null or a default value
        // This regex finds NaN values that are not inside quotes
        text = text.replace(/:\s*NaN\b/g, ': null');
        text = text.replace(/\[\s*NaN\s*\]/g, '[null]');
        text = text.replace(/,\s*NaN\s*,/g, ', null,');
        text = text.replace(/,\s*NaN\s*\]/g, ', null]');
        text = text.replace(/\[\s*NaN\s*,/g, '[null,');

        // Also handle Infinity values
        text = text.replace(/:\s*Infinity\b/g, ': null');
        text = text.replace(/:\s*-Infinity\b/g, ': null');

        try {
          analysisResults = JSON.parse(text);
          console.log('Parsed analysis results:', analysisResults);
        } catch (parseError) {
          console.error('JSON parse error after cleaning:', parseError);
          console.error('Problematic text sample:', text.substring(0, 1000));
          throw new Error(`Invalid JSON format in analysis results: ${parseError.message}`);
        }
      } else {
        throw new Error('No data found in S3 response');
      }

      dispatch({
        type: FETCH_CROSSTABLE_S3_DATA_SUCCESS_ACTION,
        payload: {
          analysisId: crossTableDataObj.id,
          results: analysisResults,
          s3Path: s3Path
        }
      });

      toast.success('Cross table analysis results loaded successfully');

      return analysisResults;

    } catch (err) {
      console.error('Error fetching cross table S3 data:', err);

      // Handle different types of errors
      let errorMessage = 'Failed to load cross table analysis results';

      if (err.code === 'NoSuchKey' || err.message?.includes('NoSuchKey')) {
        errorMessage = 'Analysis results not found. The analysis may still be processing.';
      } else if (err.code === 'AccessDenied') {
        errorMessage = 'Access denied to analysis results';
      } else if (err.name === 'SyntaxError' || err.message?.includes('JSON')) {
        errorMessage = 'Analysis results contain invalid data format. This may indicate the analysis is still in progress or encountered errors during processing.';
      }

      dispatch({
        type: FETCH_CROSSTABLE_S3_DATA_ERROR_ACTION,
        payload: {
          error: err,
          message: errorMessage
        }
      });

      toast.error(errorMessage);
      // throw err;
    }
  };
};

export const SAVE_CROSS_TABLE_QUESTIONS_SUCCESS = "SAVE_CROSS_TABLE_QUESTIONS_SUCCESS";
export const SAVE_CROSS_TABLE_QUESTIONS_ERROR = "SAVE_CROSS_TABLE_QUESTIONS_ERROR";

export const generateCrossTable = (payload, tenant) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SAVE_IN_PROGRESS })
      let analysis;
      const saveObject = new CrossTableDTO(payload, tenant);

      if (saveObject.id === undefined) {
        await createItemWs(saveObject, getState)
          .then((result) => {
            analysis = result.data;
            dispatch({
              type: SAVE_CROSS_TABLE_QUESTIONS_SUCCESS,
              payload: analysis,
            });
          })
          .catch((err) => {
            console.log(err);
            dispatch({ type: SAVE_CROSS_TABLE_QUESTIONS_ERROR, err });
            throw err;
          });
      } else {
        await updateItemWs(saveObject, getState)
          .then((result) => {
            analysis = result.data;
            dispatch({
              type: SAVE_CROSS_TABLE_QUESTIONS_SUCCESS,
              payload: analysis,
            });
          })
          .catch((err) => {
            console.log(err);
            dispatch({ type: SAVE_CROSS_TABLE_QUESTIONS_ERROR, err });
            throw err;
          });
      }
      let dbQuery = {
        "PK": analysis.PK,
        "SK": analysis.SK,
        "tenantName": tenant.name
      }
      await crossTableAnalysis(dbQuery, getState);
      toast.success("Cross table analysis started.");
      toast.info("Please give the analysis 30 min to complete.");

    } catch (err) {
      console.log('Generate cross table error:', err);
      toast.error("Failed to start Cross Table analysis.");
    } finally {
      dispatch({ type: SAVE_PROCESS_DONE })
    }
  };
}


export const CLEAR_DEEPANALYSIS_QUERY_ACTION = "CLEAR_DEEPANALYSIS_QUERY_ACTION";
export const SET_SELECTED_CUSTOM_QUERY_ACTION = "SET_SELECTED_CUSTOM_QUERY_ACTION";

export const clearDeepAnalysisQueryAction = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_DEEPANALYSIS_QUERY_ACTION,
    });
  };
}

export const DELETE_CUSTOMANALYSIS_QUERY_ACTION = "DELETE_CUSTOMANALYSIS_QUERY_ACTION";

export const deleteCustomQueryAction = (query) => {
  return async (dispatch, getState) => {
    try {
      const saveObject = new CustomAnalysisDTO(query);
      saveObject.status = "isDeleted";
      saveObject.op = "d";
      await updateItemWs(saveObject, getState);

      dispatch({
        type: DELETE_CUSTOMANALYSIS_QUERY_ACTION,
        payload: query,
      });

      toast.success("Custom query deleted successfully.");
    } catch (err) {
      console.log('Delete error:', err);
      toast.error("Failed to delete custom query.");
    }
  };
}

export const setSelectedCustomQueryAction = (query) => {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_CUSTOM_QUERY_ACTION,
      payload: query,
    });
  };
}